import dayjs from "dayjs";
import store from "@/store/pms/landlord/index";

export default function () {
    /**
     * 获取表格最大滚动高度
     * @param {*} dom 减去的dom
     * @returns
     */
    function countTable(dom = "") {
        if (dom) {
            let newDom = dom.value ? dom.value : dom;
            if (store.state.ContentHeight) {
                return store.state.ContentHeight - newDom.clientHeight - 90;
            } else {
                return localStorage.getItem("ContentHeight") - newDom.clientHeight - 90;
            }
        } else {
            if (store.state.ContentHeight) {
                return store.state.ContentHeight - 90;
            } else {
                return localStorage.getItem("ContentHeight") - 90;
            }
        }
    }

    /**
     * 计算modal位置
     * @param {*} dom
     * @returns
     */
    function countModal(dom) {
        return {
            left: dom.offsetLeft,
            top: dom.offsetTop + dom.offsetHeight + 3,
        };
    }

    /**
     * 裁剪图片-阿里云
     * @param {*} img 原图片地址
     * @param {*} size 默认m,可选s'm'l'xl'a
     * @returns 裁剪后图片地址
     */
    function imgCut(img, size = "m") {
        let s = "?x-oss-process=image/resize,m_fill,h_180,w_240";
        let m = "?x-oss-process=image/resize,m_fill,h_360,w_480";
        let l = "?x-oss-process=image/resize,m_fill,h_600,w_800";
        let xl = "?x-oss-process=image/resize,m_fill,h_900,w_1200";
        let a = "?x-oss-process=image/resize,m_fill,h_180,w_180";
        let imgUrl = "";
        if (size === "s") {
            imgUrl = s;
        } else if (size === "m") {
            imgUrl = m;
        } else if (size === "l") {
            imgUrl = l;
        } else if (size === "xl") {
            imgUrl = xl;
        } else if (size === "a") {
            imgUrl = a;
        }
        return img + imgUrl;
    }

    /**
     * 计算日期间 所有日期
     * @param {*} stime 开始时间戳
     * @param {*} etime 结束时间戳
     * @returns  日期内所有时间
     */
    function diffDate(stime, etime) {
        if (!stime || !etime) {
            console.warn("传入时间有误！");
            return [];
        }
        if (stime > etime) {
            [stime, etime] = [etime, stime];
        }
        let dates = new Array();
        while (stime <= etime) {
            dates.push(stime);
            let stime_ts = new Date(stime).getTime();
            let next_date = stime_ts + 24 * 60 * 60 * 1000;
            let nextD = new Date(next_date);
            stime = `${nextD.getFullYear()}-${(nextD.getMonth() + 1 + "").padStart(
                2,
                "0"
            )}-${(nextD.getDate() + "").padStart(2, "0")}`;
        }
        return dates;
    }

    /**
     * 计算距离当前时间的差异文本
     * @param {*} time 时间戳
     * @returns 如 "5分钟前"
     */
    function diffTime(time) {
        let second = dayjs().unix();
        let condition = second - time;
        let text = "";
        if (condition >= 8553600) {
            text = "失联很久了";
        } else if (condition >= 86400) {
            text = `${parseInt(condition / 60 / 60 / 24)}天前`;
        } else if (condition >= 3600) {
            text = `${parseInt(condition / 60 / 60)}小时前`;
        } else if (condition >= 60) {
            text = `${parseInt(condition / 60)}分钟前`;
        } else {
            text = "刚刚";
        }
        return text;
    }

    return {
        imgCut,
        countModal,
        countTable,
        diffDate,
        diffTime,
    };
}
